import { isWebGLEnabled } from '@src/slide/infrastructure/module/dependent/3d/webgl';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

/**
 * 特定场景默认不渲染 3d
 * @returns 是否应该渲染 3d
 */
export function shouldRender3D(): boolean {
    return !__IS_SSR__ && !browser.isMobile
        && isWebGLEnabled();
}
